export default __webpack_public_path__ + "8bc5bf8cb6dffdcfa9b08d23fa0582c8.svg";